import { Icon } from '@project44/manifest-ui-deprecated';
import { designTokens as dt } from '@project44/manifest-ds';

export const CompletedIcon = ({
  fillColor = `${dt.colorBorderSuccess}`,
  width = 24,
  height = 18,
}) => {
  return (
    <Icon
      data-testid="completed-icon"
      viewBox="0 0 24 18"
      width={width}
      height={height}
    >
      <path
        d="M7.73339 14.2L2.13339 8.59998L0.266724 10.4666L7.73339 17.9333L23.7334 1.93332L21.8667 0.0666504L7.73339 14.2Z"
        fill={fillColor}
      />
    </Icon>
  );
};

export default CompletedIcon;
